var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeagueBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-League-Black"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "League-Black",
    clipPath: "url(#clip-League-Black)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(-36.694 -0.81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M64.578,50.877H50.939a1.561,1.561,0,0,0-1.246,1.513v1.03a.431.431,0,0,0,.422.422H65.381a.424.424,0,0,0,.422-.422V52.39A1.536,1.536,0,0,0,64.578,50.877Z",
    transform: "translate(-3.051 -21.032)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M62.554,17.832a9.575,9.575,0,0,0,2.005-3.011,17.793,17.793,0,0,0,.853-3.092c.12-.6.217-1.168.293-1.62.1-.592.158-.984.163-1H48.94c.005.016.065.408.163,1,.076.451.174,1.022.293,1.62a16.88,16.88,0,0,0,.853,3.092,9.575,9.575,0,0,0,2.005,3.011,16.655,16.655,0,0,0,1.435,1.174A4.929,4.929,0,0,1,54.9,20.289a3.858,3.858,0,0,1,.223.451,16.464,16.464,0,0,1,.533,2.679h3.505A15.917,15.917,0,0,1,59.7,20.74a3.118,3.118,0,0,1,.217-.451,5.022,5.022,0,0,1,1.206-1.283A16.655,16.655,0,0,0,62.554,17.832Z",
    transform: "translate(-2.707 -1.963)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M56.959,37.021H55.106a2.139,2.139,0,0,0-2.119,1.842l-.647,4.826H65.573l-.658-4.826A2.139,2.139,0,0,0,62.8,37.01H56.959Z",
    transform: "translate(-4.26 -14.701)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M47.338,6.223a.641.641,0,0,0,.25.049H65.31a.668.668,0,0,0,.255-.049.721.721,0,0,0,.478-.674.735.735,0,0,0-.734-.739H47.588a.731.731,0,0,0-.728.739A.716.716,0,0,0,47.338,6.223Z",
    transform: "translate(-1.758)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M77.077,10.95h-.516c-.071.44-.168,1.005-.283,1.614l.772-.005.038.011.038.005a.311.311,0,0,1,.207.12.306.306,0,0,1,.054.239,7.927,7.927,0,0,1-4.1,6.217c-.049.06-.109.12-.163.174a10.427,10.427,0,0,1-1.114.94,5.412,5.412,0,0,0-1.342,1.277,8.946,8.946,0,0,0,6.163-3.185A10.984,10.984,0,0,0,79,13.167a2.409,2.409,0,0,0,.011-.283A1.934,1.934,0,0,0,77.077,10.95Z",
    transform: "translate(-12.628 -2.803)",
    stroke: "#000",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M50.01,20.265a11.04,11.04,0,0,1-1.12-.94c-.06-.06-.114-.12-.168-.179h-.005a7.946,7.946,0,0,1-4.081-6.212.306.306,0,0,1,.054-.239.311.311,0,0,1,.207-.12l.038-.005.038-.011.772.005c-.114-.609-.217-1.174-.288-1.614h-.516a1.938,1.938,0,0,0-1.929,1.935,2.394,2.394,0,0,0,.016.283,10.983,10.983,0,0,0,2.163,5.19,8.946,8.946,0,0,0,6.168,3.185A5.537,5.537,0,0,0,50.01,20.265Z",
    transform: "translate(0 -2.803)",
    stroke: "#000",
    strokeWidth: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeagueBlack);
export default __webpack_public_path__ + "static/media/League-Black.be89eb05575bd6a3fc442e568e73c70f.svg";
export { ForwardRef as ReactComponent };